// Vue app
import Vue from "vue";
import App from "./App.vue";

import "@/styles/main.css";
import TrackHelper from "@/helpers/utilities/TrackHelper";

import PiniaStore from "@/stores";
import { useSettingsStore } from "@/stores/settings";
import { i18n, loadLanguageAsync } from "@/helpers/utilities/I18nHelper";

// Helpers
import { router, setTranslater } from "./router";
import { default as store } from "@/helpers";
import apiGraph from "@/helpers/api/apiGraph";
import msalConnection from "@/helpers/api/msalConnection";
import apiSkobo from "@/helpers/api/apiSkobo";

import { SessionHelper } from "@/helpers/utilities/sessionHelper";
import FontAwesomeHelper from "@/helpers/utilities/FontAwesomeHelper";

// Plugins
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import GlobalSnackbar from "@/components/Shared/GlobalSnackbar";

/**********************************************/
// TRACKER
/**********************************************/
TrackHelper.initialize();

/**
 *
 */
export async function initialize() {
  try {
    let apiTokenFromQuery;

    if (window.location.search.substring(1).indexOf("token=") === 0) {
      apiTokenFromQuery = window.location.search.substring(1).replace("token=", "");
      if (apiTokenFromQuery != null || apiTokenFromQuery.length != 0) {
        // Remove token from URL
        window.history.pushState("object or string", "Title", window.location.href.split("?")[0]);
      }
    } else {
      apiTokenFromQuery = SessionHelper.nctSessionToken();
    }

    if (apiTokenFromQuery && apiTokenFromQuery.length) {
      // Setup router
      SessionHelper.login(apiTokenFromQuery);
      apiSkobo.init(router);

      // Setup pinia
      const pinia = PiniaStore.init();

      setTranslater(i18n);

      Object.defineProperty(Vue.prototype, "$locale", {
        get: function () {
          return i18n.locale;
        },
        set: function (locale) {
          i18n.locale = locale;
        }
      });

      /**********************************************/
      // FONT-AWESOME
      /**********************************************/
      FontAwesomeHelper.initFontAwesome();
      Vue.component("font-awesome-icon", FontAwesomeIcon);

      /**********************************************/
      // MISCELLANEOUS SETUP
      /**********************************************/
      Vue.prototype.$skboMessage = GlobalSnackbar.messageState;
      Vue.prototype.$ncProfile = { HideFileExtensions: false };

      Vue.config.productionTip = false;

      /**********************************************/
      // CREATE VM
      /**********************************************/

      const vm = new Vue({
        router,
        store,
        pinia,
        i18n,
        render: h => h(App)
      });

      /**********************************************/
      // SETUP GRAPH API
      /**********************************************/
      await apiGraph.initGraphApi(
        import.meta.env.VITE_APP_MSGRAPH_API_ENDPOINT,
        import.meta.env.VITE_APP_MSGRAPH_API_ENDPOINT_NEW
      );

      /**********************************************/
      // SETUP MSAL
      /**********************************************/

      const settingsStore = useSettingsStore();
      await settingsStore.loadSetup();

      msalConnection.init(settingsStore.interfaces.tenant, settingsStore.interfaces.graphAPIClientId);

      /**********************************************/
      // MOUNT VM
      /**********************************************/
      vm.$mount("#app");

      const pathForLoad = SessionHelper.nextLoginRoute;
      if (pathForLoad) {
        window.location.replace(pathForLoad);
      }
      SessionHelper.deleteNextLoginRoute();

      /**********************************************/
      // Forms detection for handling if input has value
      /**********************************************/

      document.addEventListener("change", function (event) {
        let element = event.target;
        if (element && element.matches(".form-element-field")) {
          element.classList[element.value ? "add" : "remove"]("-hasvalue");
        }
      });
    } else {
      // If we have a route but is not actively logged out (eg. we do  not have a system name) redirect to kviklogin
      if (!SessionHelper.customerSystemName) {
        sendToKviklogin();
        return;
      }

      const pinia = PiniaStore.init();

      loadLanguageAsync(import.meta.env.VITE_APP_I18N_FALLBACK_LOCALE, import.meta.env.VITE_APP_I18N_FALLBACK_VARIANT);

      new Vue({
        router,
        pinia,
        i18n,
        render: h => h(App)
      }).$mount("#app");
    }
  } catch {
    sendToKviklogin();
  }
}

initialize();

/**
 * Sends browser to kviklogin
 */
function sendToKviklogin() {
  SessionHelper.nextLoginRoute = window.location.pathname;
  if (import.meta.env.VITE_APP_NCT_LOGIN_ENDPOINT) {
    window.location.replace(import.meta.env.VITE_APP_NCT_LOGIN_ENDPOINT);
  } else {
    window.location.replace("https://kviklogin.dk");
  }
}
